import { createContext } from 'react';

const LinkContext = /*#__PURE__*/createContext(undefined);

export { LinkContext };
